import React from 'react'

import { Button } from 'components'
import { Autorenew, CheckCircleOutline } from '@mui/icons-material'

import styles from './styles'

export default (props) => {
  const classes = styles()
  const { saved, edited, loading, onClick, variant, disabled } = props

  const selectColor = (wasSaved, wasEdited, isDisabled) => {
    if (isDisabled) {
      return 'primary'
    }
    if (wasEdited) {
      return 'warning'
    }
    if (wasSaved) {
      return 'success'
    }
    return 'primary'
  }

  return (
    <Button
      color={selectColor(saved, edited, disabled)}
      onClick={onClick}
      variant={variant}
      disabled={disabled}
    >
      {edited && saved ? (
        <span className={classes.buttonLabel}>
          <span className={loading ? classes.spin : classes.icons}>
            <Autorenew />
          </span>
          <span>Atualizar Resposta</span>
        </span>
      ) : null}
      {saved && !edited ? (
        <span className={classes.buttonLabel}>
          <span className={classes.icons}>
            <CheckCircleOutline />
          </span>
          <span>Resposta Salva</span>
        </span>
      ) : null}{' '}
      {(edited && !saved) || (!edited && !saved) ? (
        <span className={classes.buttonLabel}>
          {loading ? (
            <span className={loading ? classes.spin : classes.icons}>
              <Autorenew />
            </span>
          ) : null}
          <span>Salvar Resposta</span>
        </span>
      ) : null}
    </Button>
  )
}
